import React from 'react';

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-white flex items-center justify-center">
      <div className="container max-w-5xl mx-auto px-6 text-center">
        
        {/* Section Title */}
        <h2 className="text-4xl lg:text-5xl font-bold text-hector-black leading-tight mb-6">
          Why Smart Amazon Pros Are Building a{" "}
          <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">
            Second Revenue Stream
          </span>
        </h2>

        {/* Section Description */}
        <div className="text-lg text-hector-dark-grey leading-relaxed space-y-4 mb-10">
          <p>
            You know how to close deals in the Amazon space, whether running agencies, building brands, freelancing, or managing finances. Your network has real value.
          </p>
          <p>
            Brands struggling with Amazon DSP complexity and scattered ad data need solutions that work. Hector AI solves a $50K+ annual problem for these brands.
          </p>
          <p className="font-semibold text-hector-blue">
            When you refer them, you create a revenue stream that pays you every month.
          </p>
        </div>

        {/* CTA */}
        <div className="space-y-4">
      <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <button 
    className="cta-button px-10 py-5 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)"
    }}
  >
    JOIN THE HECTOR AFFILIATE PROGRAM
  </button>
</a>

          <p className="text-sm text-gray-600">
            <span className="font-bold text-hector-black">Amazon agencies and freelancers are </span> earning 4-5 figures monthly
          </p>
        </div>
        
      </div>
    </section>
  );
};

export default Benefits;
